import localize from '../../../../common/localize';
import ReportSectionTitle from '../../../../components/common/ReportSectionTitle';
import TableComponentForReport from './TableComponentForReports';
import ValueOrNoDataLabel from '../../../../components/common/ValueOrNoDataLabel';

export default function ReportSupplyData({ supplyUsageData }) {
  return (
    <div>
      <ReportSectionTitle title={localize.supplies_report} />

      <div className="report_section_without_top_border">
        {supplyUsageData?.length > 0 ? (
          <TableComponentForReport
            headers={[localize.quantity, localize.name, localize.observations, localize.reported_by]}
            rows={supplyUsageData?.map((supply) => [
              <ValueOrNoDataLabel
                data={`${supply.Quantity} ${
                  supply.SupplyData?.Unit?.Symbol &&
                  supply.SupplyData?.Unit?.Symbol !== ''
                    ? `${supply.SupplyData?.Unit?.Symbol}`
                    : `${supply.SupplyData?.Unit?.Name}`
                }`}
                hideBackground
                centerValue
              />,
              <ValueOrNoDataLabel
                data={supply.SupplyData?.Name}
                hideBackground
                centerValue
              />,
              <ValueOrNoDataLabel
                data={supply.Observation}
                hideBackground
                centerValue
              />,
              <ValueOrNoDataLabel
                data={supply.CreatedBy}
                hideBackground
                centerValue
              />,
            ])}
          />
        ) : (
          <label className="report_little_text">{localize.no_data}</label>
        )}
      </div>
    </div>
  );
}
